import type { HttpMock } from '#e2e-utils/mockScenarios';

export const nordicUserMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: 'internalUsers',
    },
    response: {
      status: 200,
      body: [{ businessEmail: 'johnsson@gmail.fr', businessUnit: 'NORDIC' }],
    },
  },
];
